// Added by Sejune Oh on 2019-09-20
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { GetQueryReturn } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { UserElementProps, UserCustomInfoProp } from '../user'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqGetListUsers = async (path: string) => {
  return await axios.get<GetQueryReturn<UserElementProps>>(`/v1/mgmt/users?${path}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetUserProps extends UserElementProps { }
export const reqGetUser = async (id: string) => {
  return await axios.get<ResGetUserProps>(`/v1/mgmt/users/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResCreateUserProps extends UserElementProps { }
export const reqCreateUser = async (UserElementProps: UserElementProps) => {
  return await axios.post<ResCreateUserProps>('/v1/mgmt/users', { ...UserElementProps })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqDeleteUser = async (id: string) => {
  return await axios.delete(`/v1/mgmt/users/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResUpdateUserProps extends UserElementProps { }
export const reqUpdateUser = async (id: string, UserElementProps: UserElementProps) => {
  return await axios.put<ResUpdateUserProps>(`/v1/mgmt/users/${id}`, { ...UserElementProps })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResResetAuth2Data {
  success:boolean
}
export const reqResetAuth2Data = async (id: string) => {
  return await axios.post<ResResetAuth2Data>(`/v1/mgmt/users/${id}/auth2:reset`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetAssignedDataStorages {
  id: string
  name: string
  description: string
  data_token: string
  import_token: string
  connected: boolean
  fk_group_id: string
  group_key: string
}
export const reqGetAssignedDataStorages = async (id: string) => {
  return await axios.get<GetQueryReturn<ResGetAssignedDataStorages>>(`/v1/mgmt/users/${id}/assigned-datastorages`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetAssignedGroups {
  id: string
  group_key: string
  description: string
}
export const reqGetAssignedGroups = async (id: string) => {
  return await axios.get<GetQueryReturn<ResGetAssignedGroups>>(`/v1/mgmt/users/${id}/assigned-groups`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResAssignGroupsToUser { }
export const reqAssignGroupsToUser = async (id: string, fk_group_ids: Array<string>) => {
  return await axios.put<ResAssignGroupsToUser>(`/v1/mgmt/users/${id}/assigned-groups`, {
    fk_group_ids,
  })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ReqChangeUserPassword {
  id: string
  new_password: string
  cur_password: string
}
interface ResChangeUserPassword { }
export const reqChangeUserPassword = async (id: string, newPwElement: ReqChangeUserPassword) => {
  return await axios.put<ResChangeUserPassword>(`/v1/mgmt/users/${id}/change-pw`, {
    ...newPwElement,
  })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResResetUserPassword {
  password: string
}
export const reqResetUserPassword = async (id: string) => {
  return await axios.put<ResResetUserPassword>(`/v1/mgmt/users/${id}/reset-pw`, { id })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResSetUserCustomInfos { }
export const reqSetUserCustomInfos = async (id: string, customInfos: UserCustomInfoProp[]) => {
  return await axios.put<ResSetUserCustomInfos>(`/v1/mgmt/users/${id}/user-custom-infos`,
    {
      id,
      user_custom_infos: [...customInfos]
    })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResDeleteUserCustomInfos { }
export const reqDeleteUserCustomInfos = async (id: string, customInfoKeys: string[]) => {
  return await axios.post(`/v1/mgmt/users/${id}/user-custom-infos:delete`,
    {
      id,
      keys: [...customInfoKeys]
    })
}
